export let PayInMethodCode;

(function (PayInMethodCode) {
  PayInMethodCode["CreditCard"] = "CREDIT_CARD";
  PayInMethodCode["MangoPayPaypal"] = "MANGOPAY_PAYPAL";
  PayInMethodCode["Sofort"] = "SOFORT";
  PayInMethodCode["Ideal"] = "IDEAL";
  PayInMethodCode["Maual"] = "MANUAL";
  PayInMethodCode["Wallet"] = "WALLET";
  PayInMethodCode["P24"] = "P24";
  PayInMethodCode["Trustly"] = "TRUSTLY";
  PayInMethodCode["Payconiq"] = "PAYCONIQ";
  PayInMethodCode["BlikDirect"] = "BLIK_DIRECT";
  PayInMethodCode["ApplePay"] = "APPLE_PAY";
  PayInMethodCode["GooglePay"] = "GOOGLE_PAY";
})(PayInMethodCode || (PayInMethodCode = {}));